'use strict';

module.exports = {
    LANG: 'it-it',
    SIGN: 'Accedi',
    REGISTER: 'Registrare',
    QUICK_ACCESS: 'Accesso rapido con',
    SIGN_JOIN: 'Registrati o diventa membro gratis!',
    NOT_MEMBER: 'Non sei un membro?',
    ALREADY_MEMBER: 'Sei già membro di AliExpress/Alibaba?',
    SHOW_ALL: 'Mostra tutto',
    HIDE: 'Nascondi',
    GUID: 'Vuoi vendere su AliExpress?',
    GUID_HREF: 'Clicca qui'
};